import { useMemo } from "react";

const GUIDANCE_LENGTH_LIMIT = 400;

export const useFrameworkGuidance = (guide?: string) => {
    const tooLongGuidance = guide && guide.length > GUIDANCE_LENGTH_LIMIT;

    const displayedGuidance = useMemo(
        () =>
            guide
                ?.slice(0, GUIDANCE_LENGTH_LIMIT)
                .concat(tooLongGuidance ? "..." : "") || "",
        [guide, tooLongGuidance],
    );

    return {
        displayedGuidance,
        tooLongGuidance,
        fullGuidance: guide,
    };
};
